import { apiInstance, gql } from "@/services/httpAdapter";

export async function getTrainingSideBar({ locationId }) {
	const query = gql`
		query getCommissionCyclesTraining($locationId: String!) {
			getCommissionCyclesTraining(locationId: $locationId) {
				_id
				title
				startDate
				status
				endDate
				training {
					trainingId
					itemsCount
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCommissionCyclesTraining;
	} catch (err) {
		throw new Error(err);
	}
}

export async function getTraining(locationId, commissionCycleId) {
	const query = gql`
		query getTraining($locationId: String!, $commissionCycleId: String!) {
			getTraining(locationId: $locationId, commissionCycleId: $commissionCycleId) {
				_id
				commissionCycleId
				createdAt
				createdBy {
					_id
					fullName
				}
				items {
					_id
					createdAt
					createdBy {
						_id
						fullName
					}
					effectiveDateFrom
					effectiveDateTo
					pay {
						input
						value
					}
					updatedAt
					updatedBy {
						_id
						fullName
					}
					userId {
						_id
						fullName
						employeeId
					}
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data?.data?.getTraining;
	} catch (err) {
		throw new Error(err);
	}
}

export async function getMyTraining(locationId, commissionCycleId, userId) {
	const query = gql`
		query getMyTraining($locationId: String!, $commissionCycleId: String!, $userId: String!) {
			getMyTraining(locationId: $locationId, commissionCycleId: $commissionCycleId, userId: $userId) {
				_id
				createdAt
				createdBy {
					_id
					fullName
				}
				effectiveDateFrom
				effectiveDateTo
				pay {
					input
					value
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
				userId {
					_id
					fullName
					employeeId
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		userId,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data?.data?.getMyTraining;
	} catch (err) {
		throw new Error(err);
	}
}
